import './App.css';
import Prayer from './Components/Prayer/Prayer';
import Header from './Components/Header/Header';
import MainContant from './Components/MainContant/MainContant';

function App() {
  return<>
  
  <Header/>
  <MainContant/>
  
  </>
}

export default App;
